import { ELKReportName } from '@/types'
import { elkReport } from '@/utils'
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs'
import React, { useEffect } from 'react'
import './app.less'

// 初始化主题
const initTheme = () => {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem('app-theme') || 'dark'
    const root = document.documentElement
    if (savedTheme === 'light') {
      root.classList.remove('dark-theme')
      root.classList.add('light-theme')
      root.setAttribute('theme-mode', 'light')
    } else {
      root.classList.remove('light-theme')
      root.classList.add('dark-theme')
      root.setAttribute('theme-mode', 'black')
    }
  }
}

// 在应用启动时初始化主题
if (typeof window !== 'undefined') {
  initTheme()
}

// 运行时环境标识
const isDev = process.env.NODE_ENV === 'development'

let qiankunProps = {
  path: '',
}
export const qiankun = {
  // 应用加载之前
  async bootstrap(props: any) {
    if (isDev) console.log('app1 bootstrap', props)
    props ? (qiankunProps = props) : ''
  },
  // 应用 render 之前触发
  async mount(props: any) {
    if (isDev) console.log('app1 mount', props)
    // props.base = 'main/app/smart-qa';
  },
  // 应用卸载之后触发
  async unmount(props: any) {
    if (isDev) console.log('app1 unmount', props)
  },
}

export function patchRoutes({ routes }: any) {
  if (isDev) console.log(routes, qiankunProps, (window as any).__POWERED_BY_QIANKUN__)
}

export function rootContainer(container: React.ReactElement) {
  return React.createElement(
    StyleProvider,
    {
      hashPriority: 'high',
      transformers: [legacyLogicalPropertiesTransformer],
    },
    container,
  )
}

export const locale = {
  default: 'en-US',
}

// 捕获全局异常错误
window.addEventListener(
  'error',
  (e) => {
    if (isDev) console.error('捕获到异常：', e)

    elkReport({
      name: ELKReportName.errorInfo,
      message: e.message,
      grade: 'Error',
      category: 'js',
      stack: e.error?.stack ?? '-',
    })
  },
  true,
)
